import { Component, OnInit } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { ModalComponent } from '../../Shared/Components/modal/modal.component';
declare var $: any;



@Component({
  selector: 'app-offering',
  templateUrl: './offering.component.html',
  styleUrls: ['./offering.component.scss']
})
export class OfferingComponent implements OnInit {
  modalRef!: MDBModalRef;

  ASDCoreHeader!: string;
  ASDIndustryHeader!: string;

  offeringHeader="Our Offerings";

  constructor(
    private _http: HttpClientModule,
    private modalService: MDBModalService
  ) { }

  ngOnInit(): void {
    this.getTextValues();
    this.btnStartClick() 
  }

   btnStartClick() {     
    $('#core-tab-md').tab('show');
    
  }


  getTextValues() {
    this.ASDCoreHeader = "ASD CORE OFFERINGS FOR SAP APPLICATIONS";
    this.ASDIndustryHeader = "INDUSTRY OFFERINGS";
  }

  getElementDetails(elementId: string) {


    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
      data: {
        selectedoffering: elementId,
      }
    }
    this.modalRef = this.modalService.show(ModalComponent, modalOptions)
  }

}
